
import { RecentPayment } from '@/types/RecentPayment'
import { defineComponent, onUpdated, PropType, ref } from 'vue'

export default defineComponent({
  name: 'DropdownAction',
  props: {
    item: {
      type: Object as PropType<RecentPayment>,
      required: true,
    },
  },
  emits: ['delete'],
  setup({ item }, { emit }) {
    const toggleDetail = ref(false)
    const deleteItem = () => {
      toggleDetail.value = false

      setTimeout(() => {
        emit('delete', item)
      }, 250)
    }

    return { toggleDetail, deleteItem }
  },
})
